/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SharedSalesDocumentsRpc
 */
import * as References from './SharedSalesDocumentsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SharedSalesDocumentsRpc#listSharedSalesDocuments
 */
export const LIST_SHARED_SALES_DOCUMENTS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_SharedSalesDocumentsRpc_listSharedSalesDocuments';
export const LIST_SHARED_SALES_DOCUMENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_SHARED_SALES_DOCUMENTS_QUERY_FIELD_NAME,
  args: ['queryObjectTypeId', 'queryObjectId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied', 'limit', 'offset', 'contextObjects'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.listSharedSalesDocumentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SharedSalesDocumentsRpc#listSharedSalesDocumentsByScopeObjects
 */
export const LIST_SHARED_SALES_DOCUMENTS_BY_SCOPE_OBJECTS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_SharedSalesDocumentsRpc_listSharedSalesDocumentsByScopeObjects';
export const LIST_SHARED_SALES_DOCUMENTS_BY_SCOPE_OBJECTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_SHARED_SALES_DOCUMENTS_BY_SCOPE_OBJECTS_QUERY_FIELD_NAME,
  args: ['scopeObjects', 'limit', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied', 'contextObjects'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.listSharedSalesDocumentsByScopeObjectsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SharedSalesDocumentsRpc#shareSalesDocuments
 */
export const SHARE_SALES_DOCUMENTS_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_SharedSalesDocumentsRpc_shareSalesDocuments';
export const SHARE_SALES_DOCUMENTS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SHARE_SALES_DOCUMENTS_MUTATION_FIELD_NAME,
  args: ['salesDocumentIds', 'requireEmail', 'allowDownload', 'scopeObjectTypeId', 'scopeObjectId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.shareSalesDocumentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});